export default "__VITE_ASSET__DRZrs7p5__"